export default __webpack_public_path__ + "static/media/0444_DSC6914.7cf21e10.jpg";